/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_SourceInputs */

const en_app_endpoint_source = /** @type {(inputs: App_Endpoint_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const zh_hans1_app_endpoint_source = /** @type {(inputs: App_Endpoint_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据源`)
};

const pt_br2_app_endpoint_source = /** @type {(inputs: App_Endpoint_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const es_app_endpoint_source = /** @type {(inputs: App_Endpoint_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

const fr_app_endpoint_source = /** @type {(inputs: App_Endpoint_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const de_app_endpoint_source = /** @type {(inputs: App_Endpoint_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle`)
};

const ru_app_endpoint_source = /** @type {(inputs: App_Endpoint_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источник`)
};

const it_app_endpoint_source = /** @type {(inputs: App_Endpoint_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {App_Endpoint_SourceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_source = /** @type {((inputs?: App_Endpoint_SourceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_SourceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_source(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_source(inputs)
	if (locale === "es") return es_app_endpoint_source(inputs)
	if (locale === "fr") return fr_app_endpoint_source(inputs)
	if (locale === "de") return de_app_endpoint_source(inputs)
	if (locale === "ru") return ru_app_endpoint_source(inputs)
	if (locale === "it") return it_app_endpoint_source(inputs)
	return en_app_endpoint_source(inputs)
});